export default {
  order_methods: {
    delivery: 'Delivery',
    pickup: 'Pickup',
    room_service: 'On site',
    table_service: 'On site',
  },
  time: '{{time}} min',
  asap: 'ASAP',
  unavailable: 'Unavailable',
  ready_in: 'Ready in ',
  buttons: {
    change: 'Change',
    see_hours: 'See hours',
    change_location: 'Change location',
    change_time: 'Change time',
  },
};
